module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_iterators.js
// module id = fKFs
// module chunks = 0